import { redirect } from 'react-router-dom';
import { EstudiApiClient } from '../../services/interfaces/EstudiApiClient/EstudiApiClient';

export const loader =
  (estudiClient: EstudiApiClient) =>
  async ({ params }: { params: Record<string, string | undefined> }) => {
    if (!params.reservationId) {
      return redirect('/');
    }

    try {
      const reservation = await estudiClient.getReservation({
        reservationId: params.reservationId,
        includeRate: true,
        includeGroup: true
      });

      return { reservation };
    } catch {
      return redirect('/');
    }
  };
